
import axios from '../../config/axiosConfig';
import { CREATE_DATE_WISE_PRODUCTION, GET_DATE_WISE_PRODUCTIONS, DATE_WISE_PRODUCTION_REQUEST, DELETE_DATE_WISE_PRODUCTION, UPDATE_DATE_WISE_PRODUCTION, DATE_WISE_PRODUCTION_REQUEST_FAILURE, GET_DATE_WISE_PRODUCTIONS_PAGE, DATE_WISE_PRODUCTION_REQUEST_SUCCESS } from '../types';

export const getValidatedIncrementedVchNoDateWiseProduction = (currentVchNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      
      const response = await axios.get("/date-wise-production/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getDateWiseProductionsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DATE_WISE_PRODUCTION_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Item,Lot'
      };
      return axios.get("/date-wise-production/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DATE_WISE_PRODUCTIONS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DATE_WISE_PRODUCTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DATE_WISE_PRODUCTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getDateWiseProductions = (include) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: DATE_WISE_PRODUCTION_REQUEST });
            const { auth } = getState();
            let params = {
                finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth?.user?.Customer_Id
            };
            if (include) {
                params = { ...params, include };
            }
            return axios.get('/date-wise-production/get', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_DATE_WISE_PRODUCTIONS, payload: response.data?.data || [] });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: DATE_WISE_PRODUCTION_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: DATE_WISE_PRODUCTION_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const getDateWiseProductionById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DATE_WISE_PRODUCTION_REQUEST });
    
      return axios.get(`/date-wise-production/get/${id}`).then((response) => {
        dispatch({ type: DATE_WISE_PRODUCTION_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DATE_WISE_PRODUCTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DATE_WISE_PRODUCTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createDateWiseProduction = (dateWiseProduction) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: DATE_WISE_PRODUCTION_REQUEST });
            axios.post('/date-wise-production/add', dateWiseProduction,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, finyearId: auth.finyear?.id }}).then((response) => {
                    if (response.data) {
                        dispatch({ type: CREATE_DATE_WISE_PRODUCTION, payload: response.data });
                    } else {
                        dispatch({ type: DATE_WISE_PRODUCTION_REQUEST_FAILURE, error: 'DateWiseProduction create failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: DATE_WISE_PRODUCTION_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: DATE_WISE_PRODUCTION_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateDateWiseProduction = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: DATE_WISE_PRODUCTION_REQUEST });
            return axios.put('/date-wise-production/update', { id, data }).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_DATE_WISE_PRODUCTION, payload: { id, data: response.data } }, { params: { userId: auth.user?.id }});
                } else {
                    dispatch({ type: DATE_WISE_PRODUCTION_REQUEST_FAILURE, error: 'DateWiseProduction update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: DATE_WISE_PRODUCTION_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: DATE_WISE_PRODUCTION_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteDateWiseProduction = (id) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: DATE_WISE_PRODUCTION_REQUEST });
            axios.delete(`/date-wise-production/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_DATE_WISE_PRODUCTION, id: id });
                    const include = ['id', 'Vch_No', 'Date', 'Taka', 'Meter', 'Weight', 'Remark'].join(',');
                    const searchCols = ['Vch_No'].join(',');
                    const { inventory: { dateWiseProduction: { page, pageSize, search, where } = {} } } = getState();
                    dispatch(getDateWiseProductionsWithPagination(page, pageSize, include, search, searchCols, where, true));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: DATE_WISE_PRODUCTION_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: DATE_WISE_PRODUCTION_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};